module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "local"
  }, [_c('div', {
    staticClass: "dropdown",
    attrs: {
      "title": _vm.$t('button_settings_title')
    }
  }, [_c('i', {
    staticClass: "icon-settings-menu icons",
    attrs: {
      "data-settings-dropdown": ""
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownVisible),
      expression: "dropdownVisible"
    }],
    staticClass: "dropdown-content"
  }, [_c('audio-device-select'), _vm._v(" "), _c('video-device-select'), _vm._v(" "), _c('options-menu-select')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "screenDropdown",
    attrs: {
      "title": _vm.$t('button_screen_share_title')
    }
  }, [_c('i', {
    class: ("" + ((_vm.sharingScreenAndVideo || _vm.sharingScreenOnly) ? 'icon-active-desktop-menu icons' : 'icon-desktop-menu icons')),
    attrs: {
      "data-screen-dropdown": ""
    },
    on: {
      "click": _vm.toggleScreenDropdown
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportScreensharing && _vm.isConnected && _vm.screenDropdownVisible),
      expression: "supportScreensharing && isConnected && screenDropdownVisible"
    }],
    staticClass: "dropdown-content"
  }, [_c('screen-menu-select')], 1)]), _vm._v(" "), _c('stream', {
    attrs: {
      "source": _vm.sourceStream,
      "is-local-stream": true,
      "id": _vm.localPeerId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cfd8303"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Local.vue
// module id = 364
// module chunks = 1